import { memo, type ReactNode, useEffect } from "react";
import type { LayoutChangeEvent } from "react-native";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withSpring,
} from "react-native-reanimated";

const ROW_REORDER_SPRING_CONFIG = {
  damping: 34,
  mass: 0.45,
  stiffness: 420,
};

export const QueueRowSWM = memo(function QueueRowSWM({
  children,
  isDraggingItem,
  onLayout,
  shouldAnimate,
  translateY,
}: {
  children: ReactNode;
  isDraggingItem: boolean;
  onLayout: (event: LayoutChangeEvent) => void;
  shouldAnimate: boolean;
  translateY: number;
}) {
  const translateYValue = useSharedValue(0);

  useEffect(() => {
    translateYValue.value = shouldAnimate
      ? withSpring(translateY, ROW_REORDER_SPRING_CONFIG)
      : translateY;
  }, [shouldAnimate, translateY, translateYValue]);

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: isDraggingItem ? 0 : 1,
    transform: [{ translateY: translateYValue.value }],
  }));

  return (
    <Animated.View onLayout={onLayout} style={animatedStyle}>
      {children}
    </Animated.View>
  );
});
